<template>
  <div class="home__container">
    <img class="home__logo" src="~/assets/soreal/real-360-dark.svg" />
  </div>
</template>

<script lang="ts" setup></script>

<style scoped lang="scss">
.home {
  &__container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: #0f206c;
  }

  &__logo {
    width: 12rem;
    margin: auto;
  }
}
</style>
